export const isKeyEnterSpace = ({ key }: { key: any }): boolean => {
  const SPACE_KEY = ' ';
  const ENTER_KEY = 'Enter';
  return key === SPACE_KEY || key === ENTER_KEY;
};
